/**
 * Calculates the length of a quat
 *
 * @param {quat} a vector to calculate length of
 * @returns {Number} length of a
 * @function
 */
module.exports = require('gl-vec4/length')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/length.js
// module id = 337
// module chunks = 0